import { put, select, takeLatest } from 'redux-saga/effects'
import { TabConstants } from '../../../components/tabs/Tabs.constants'
import { getImagingUltrasoundSelector } from '../../procedures/imagingUltrasound/selectors'
import { IImagingUltrasoundState } from '../../procedures/imagingUltrasound/store/ImagingUltrasound.types'
import { getPatientTimelineSelector } from '../selectors/patientTimeline.selector'
import { saveTimelineItems, setActivityLog } from '../store/timeline.actions'
import { TimelineConstants } from '../store/timeline.constants'
import { IItem, ITimelineState } from '../store/timeline.types'
import { generateClientCorrelationId } from '../../nemsisData/utils/customElements.util'
import { getProcedureStateSelector } from '../../../components/procedure/selectors'

export function* addImagingUltrasoundItem() {
  const timeline: ITimelineState = yield select(getPatientTimelineSelector)
  const { nemsisCodeOptions } = yield select(getProcedureStateSelector)

  const { items } = timeline
  const imagingUltraState: IImagingUltrasoundState = yield select(getImagingUltrasoundSelector)
  const { pta, addToTimeline, key, time, date, assessedBy, comments, imageType, location, findings } = imagingUltraState
  if (addToTimeline) {
    const clientCorrelationId = generateClientCorrelationId(
      nemsisCodeOptions,
      TimelineConstants.IMAGING_ULTRASOUND_PROCEDURE,
      null,
      {
        filter1: null,
        filter2: null,
        filter3: null,
      },
      key
    )
    const assessedByLabel = assessedBy?.name || ''
    const type = imageType?.name || ''
    const locationName = location?.name || ''
    const findingsName = findings?.name || ''
    const index = items.findIndex((item) => item.key === key)
    const dateTime = new Date(date || 0)
    if (time) {
      if (time.split(':').length >= 3) dateTime.setSeconds(+time.split(':')[2])
      dateTime.setMinutes(+time.split(':')[1])
      dateTime.setHours(+time.split(':')[0])
    }
    const item: IItem = {
      key: key,
      clientCorrelationId,
      grid: true,
      labelHeaderFlag: pta ? 'PTA' : '',
      labelHeader: time,
      subHeader: date,
      itemType: 'Procedures',
      event: 'Imaging/Ultrasound',
      eventSubHeader: `By ${assessedByLabel},
      Type: ${type}, Location: ${locationName}, Findings: ${findingsName}, Comments: ${comments}.`,
      rowActionType: TimelineConstants.SET_IMAGING_ULTRASOUND_ITEM,
      defaultHref: TabConstants.IMAGING_ULTRASOUND_PROCEDURE,
      date: dateTime,
    }
    if (index !== -1) {
      items[index] = item
    } else {
      items.push(item)
    }
    yield put(setActivityLog(items))
    yield put(saveTimelineItems())
  }
}

export function* addImagingUltrasoundItemSaga() {
  yield takeLatest([TimelineConstants.ADD_IMAGING_ULTRASOUND_ITEM], addImagingUltrasoundItem)
}
